export function flashtalkingTrackLead() {
    let imgTag = document.createElement('img');

    imgTag.setAttribute('src', 'https://servedby.flashtalking.com/spot/8/6867;84273;8672/?spotName=NWM_FindaProfessional_Flow9Confirmation_PL');
    imgTag.setAttribute('width', '1');
    imgTag.setAttribute('height', '1');
    imgTag.setAttribute('alt', '');
    document.body.appendChild(imgTag);
}